import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { Store, persistor } from "./redux/store/store";
import NotificationProvider from "./components/common/NotificationProvider";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={Store}>
    <PersistGate loading={null} persistor={persistor}>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </PersistGate>
  </Provider>
);
